import { Audit } from '../../auth/domain/audit';
import { Location } from '../../location';
import { Media } from '../../media';
import { Product } from '../../products';
import { Workspace } from '../../workspace';
import { Addon } from '../../add-ons/domain';

export interface Asset extends Audit {
  id: string;
  workspaces: Workspace[];
  coverImage: Media;
  media: Media[];
  name: string;
  description?: string;
  details?: string;
  lastScannedAt?: Date;
  lastAddress: string;
  lastLocation: Location;
  addons: Addon[];
  product: Product;
  serialNumber: string;
}
